import React from 'react';
import loaderIcon from './images/loader-icon.svg';

const CheckBoxSlider = (props) => {
  let errorMsg = '';

  if (props.error && props.error.length > 0) {
    errorMsg = props.error;
  }

  const handelOnChange = (e, id) => {
    if (props.onChange) {
      props.onChange(e);
    } else {
      if (e.target.checked) {
        props.onCheck(id);
      } else {
        props.onUncheck(id);
      }
    }
  };

  return (
    <label className="checkbox-slider" htmlFor={props.id}>        
        <input
            type='checkbox'
            checked={props.checked}
            id={props.id}
            name={props.name}
            onChange={(e) => { handelOnChange(e, props.id); }}
        />        
        <div className="slider round">
            { props.textChecked && <span className='text-checked'>{props.textChecked}</span> } 
            { props.textNotChecked && <span className='text-not-checked'>{props.textNotChecked}</span> }
        </div>
        { props.isShowLoader && <div className='checkbox-loader' style={{backgroundImage:loaderIcon.bg()}}></div> }
        
    </label>
  );
};

export default CheckBoxSlider;
